import {ElementRef} from '@angular/core';
import brightcovePlayerLoader from '@brightcove/player-loader';
import {Store} from '@ngrx/store';
import {FacebookPixelEventTrackerService} from './facebook-pixel-event-tracker.service';
import {State} from './state';

export class VideoComponent {
	courseId: string;
	player: any;
	requestedVideoId: string;
	videoCreating = false;
	videoHandleExists = false;
	videoStarted = false;
	videoStartPosition: number;

	playerControlsDisabled = true;

	playerVideoRef: ElementRef;

	viewLoadTimeoutHandle: NodeJS.Timeout;

	constructor(
		protected store: Store<State>,
		protected facebookPixelEventTracker: FacebookPixelEventTrackerService,
	) {
	}

	loadVideo(videoId: string, pushStats: boolean, lectureId: string = null) {
		// console.log('loadTimeout', videoId);
		//check if new load
		if (this.requestedVideoId) {
			if (this.requestedVideoId !== videoId) {
				//clear the previous item
				if (this.videoHandleExists && this.playerVideoRef) {
					// brightcovePlayerLoader.reset(); // is this the correct cleanup?
					this.playerVideoRef.nativeElement.innerHTML = '';
				}
				if (this.viewLoadTimeoutHandle) {
					clearInterval(this.viewLoadTimeoutHandle);
				}
			} else {
				return;
			}
		}

		//set current video id
		this.requestedVideoId = videoId;

		//enter load loop
		if (!this.playerVideoRef || !this.playerVideoRef.nativeElement) {
			// console.log('Video wrapper still not present!');
			// TODO timeout?
			this.viewLoadTimeoutHandle = setInterval(() => {
				// console.log('Video wrapper interval.  Player ref:', this.playerVideoRef);
				if (this.playerVideoRef && this.playerVideoRef.nativeElement) {
					this.initVideo(pushStats, lectureId);
					clearInterval(this.viewLoadTimeoutHandle);
					this.viewLoadTimeoutHandle = null;
				}
			}, 300);
			setTimeout(() => {
				if (!this.viewLoadTimeoutHandle) return;
				clearInterval(this.viewLoadTimeoutHandle);
			}, 5000);
		} else {
			// console.log('Init video?');
			this.initVideo(pushStats, lectureId);
		}
	}

	private initVideo(pushStats: boolean, lectureId: string = null) {
		if (this.videoCreating) return;

		// console.log('loading video');
		this.videoCreating = true;
		// init the new player
		brightcovePlayerLoader({
			refNode: this.playerVideoRef.nativeElement,
			accountId: '4828955589001',
			embedId: 'default',
			videoId: this.requestedVideoId, // '987654321',
			embedOptions: {
				responsive: true,
			},
			options: {
				preload: 'metadata',
			}
		}).then(result => {
			// The player has been created!
			// console.log('video created', result);
			this.videoHandleExists = true;
			this.videoCreating = false;

			if (result.ref) {
				this.player = result.ref;
				// https://docs.videojs.com/docs/api/player.html

				//invoke init function to allow children to impact player
				this.onPlayerInit();

				//if the play controls are disabled, the component will handle calling `playAndEnable()`, so we can disable the controls by default
				// if (this.playerControlsDisabled) {
				// 	this.player.controls(false);
				// }

				//if we have a resume position, grab that
				if (this.videoStartPosition) {
					this.player.currentTime(this.videoStartPosition);
				}

				this.player.on('play', () => {
					this.videoStarted = true;
				});

				this.player.on('error', () => {
					console.log('video error');
				});
			}
		}).catch(error => {
			// Player creation failed!
			console.log('video error', error);
		});
	}

	onPlayerInit() {
		//No default implementation. Here to allow subclass to inject code
	}

	playAndEnable() {
		//mark the controls as being on
		this.playerControlsDisabled = false;

		//if the player exists, play it and return its controls
		if (!this.player) return;
		if (this.player.paused()) this.player.play();
		this.player.controls(true);
	}

	clearPreviousVideoPlayer() {
		this.requestedVideoId = null;
		if (this.videoHandleExists) { // changes.lecture.previousValue.video_id) {
			// brightcovePlayerLoader.reset(); // is this the correct cleanup?
			this.playerVideoRef.nativeElement.innerHTML = '';
		}
	}
}
